import { NgModule } from "@angular/core";
import { PoButtonModule, PoModule } from "@po-ui/ng-components";
import { LoginComponent } from "./login.component";
import { PoPageLoginModule, PoTemplatesModule } from "@po-ui/ng-templates";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
  PoCheckboxModule,   // lembrar usuário
  PoLinkModule,       // link “Esqueci minha senha”
  PoContainerModule,  // cartão central
  PoTagModule         // selo de ambiente (Homologação etc.)
} from '@po-ui/ng-components';

@NgModule({
  declarations: [LoginComponent],
  exports: [LoginComponent],
  imports: [
    CommonModule,
    PoModule,
    PoPageLoginModule,
    FormsModule,
    PoButtonModule,
    PoCheckboxModule,
    PoLinkModule,
    PoContainerModule,
    PoTagModule,
    PoTemplatesModule,
    ReactiveFormsModule,
    FormsModule  
  ]
})
export class LoginModule {

}